import React from 'react'

const MusicDetail = () => {
  return (
    <div>MusicDetail</div>
  )
}

export default MusicDetail